import { pick } from 'lodash'

const menuCurationTaskTagsAndProblemsFormInitialValues = values =>
  pick(values, ['tags', 'problemReason', 'problemComment'])

export default menuCurationTaskTagsAndProblemsFormInitialValues
